import React, { useState, useEffect } from "react";
import api from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

const LOGO_H = "https://yayasanwakaftozan.org/res/logo.png";

const PROGRAM_COLORS = ["#eef9f0", "#fefce8", "#eff6ff", "#fdf4ff"];

const FALLBACK_PROFILE = [
  "Yayasan Wakaf Tongku Azhar Nahdliyyin adalah lembaga pendidikan, dakwah, dan sosial Islam yang berfokus pada pembekalan akidah yang kokoh, pemahaman syariah yang lurus, dan penanaman akhlak mulia berlandaskan ajaran Ahlusunnah wal Jamaah.",
  "Tujuan utama yayasan adalah mencetak generasi muda Islam menjadi ibadillah as-sholihin yang saleh, berintegritas tinggi, berwawasan luas, serta mampu membawa maslahat bagi agama, bangsa, dan negara.",
  "Berlokasi di Namorambe, Medan, yayasan menyelenggarakan pendidikan formal mulai dari Raudhatul Athfal (RA) hingga Madrasah Ibtidaiyah (MI) Al-Armi, dengan rencana pengembangan ke jenjang MTs dan MA di masa mendatang.",
];

const FALLBACK_PROGRAMS = [
  { level: "RA", name: "Raudhatul Athfal", desc: "Jenjang Pra-Sekolah untuk meletakkan fondasi karakter dasar Islami." },
  { level: "MI", name: "Madrasah Ibtidaiyah Al-Armi", desc: "Jenjang SD Islam yang memadukan keunggulan kurikulum umum dengan nilai kepesantrenan." },
  { level: "MTs", name: "Madrasah Tsanawiyah", desc: "Jenjang SMP Islam (dalam rencana pengembangan mendatang)." },
  { level: "MA", name: "Madrasah Aliyah", desc: "Jenjang SMA Islam (dalam rencana pengembangan mendatang)." },
];

export default function TentangKami() {
  const { settings, waUrl } = useSettings();
  const [management, setManagement] = useState([]);

  useEffect(() => {
    api.get("/org-members").then((res) => setManagement(res.data)).catch(() => setManagement([]));
  }, []);

  const profile = settings && settings.profile_paragraphs && settings.profile_paragraphs.length
    ? settings.profile_paragraphs
    : FALLBACK_PROFILE;
  const programs = settings && settings.programs && settings.programs.length
    ? settings.programs
    : FALLBACK_PROGRAMS;

  return (
    <div data-testid="tentang-kami-page" style={{ paddingTop: "72px" }}>
      {/* Page Header */}
      <div
        className="py-12 text-white text-center relative overflow-hidden"
        style={{ backgroundColor: "#198530" }}
      >
        <div className="absolute inset-0" style={{ opacity: 0.05 }}>
          <svg width="100%" height="100%">
            <defs>
              <pattern id="dots" x="0" y="0" width="30" height="30" patternUnits="userSpaceOnUse">
                <circle cx="15" cy="15" r="2" fill="white" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#dots)" />
          </svg>
        </div>
        <div className="relative z-10">
          <p className="text-sm uppercase tracking-widest mb-2" style={{ color: "#d4af37", fontFamily: "'Amiri', serif" }}>
            تَعَرَّفْ عَلَيْنَا
          </p>
          <h1 className="text-4xl md:text-5xl font-bold">Tentang Kami</h1>
          <p className="mt-3 text-sm md:text-base" style={{ color: "#bbf7d0" }}>
            Mengenal Yayasan Wakaf Tongku Azhar Nahdliyyin
          </p>
        </div>
      </div>

      {/* About Section */}
      <section className="py-12" style={{ backgroundColor: "#F8FAF8" }}>
        <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-sm uppercase tracking-widest font-semibold mb-2" style={{ color: "#d4af37" }}>
              Profil Yayasan
            </p>
            <h2 className="text-3xl font-bold text-gray-900 mb-5">
              Yayasan Wakaf Tongku Azhar Nahdliyyin
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed text-sm md:text-base">
              {profile.map((para, idx) => (
                <p key={idx}>{para}</p>
              ))}
            </div>
            <a
              href={waUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="tentang-wa-button"
              className="mt-6 inline-flex items-center gap-2 text-white px-6 py-3 rounded-xl font-semibold text-sm transition-all hover:opacity-90"
              style={{ backgroundColor: "#198530" }}
            >
              Hubungi Kami
            </a>
          </div>
          <div className="flex justify-center">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img src={LOGO_H} alt="Logo Yayasan Wakaf Tongku Azhar Nahdliyyin" className="max-w-sm w-full" />
            </div>
          </div>
        </div>
      </section>

      {/* Visi Misi */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-gray-900">Visi &amp; Misi</h2>
            <p className="text-gray-500 mt-2 text-sm">Landasan dan arah perjuangan pendidikan kami</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            {/* Visi */}
            <div className="rounded-2xl p-8 text-white" style={{ backgroundColor: "#198530" }}>
              <div className="text-4xl mb-4" style={{ fontFamily: "'Amiri', serif", color: "#d4af37" }}>رُؤْيَتُنَا</div>
              <h3 className="text-xl font-bold mb-3" style={{ color: "#d4af37" }}>VISI</h3>
              <p className="text-lg leading-relaxed italic" style={{ color: "#dcfce7" }}>
                "Terwujudnya peserta didik yang beriman, cerdas, kreatif, dan berakhlakul karimah."
              </p>
            </div>
            {/* Misi */}
            <div className="rounded-2xl p-8" style={{ backgroundColor: "#F8FAF8", border: "1px solid #dcfce7" }}>
              <div className="text-4xl mb-4" style={{ fontFamily: "'Amiri', serif", color: "#198530" }}>رِسَالَتُنَا</div>
              <h3 className="text-xl font-bold mb-4" style={{ color: "#198530" }}>MISI</h3>
              <ol className="space-y-3">
                {[
                  "Menanamkan keimanan dan ketaqwaan kepada Allah SWT.",
                  "Melaksanakan praktik ibadah, bimbingan membaca Al-Qur'an, dan kecerdasan emosional.",
                  "Menumbuhkan cara berpikir kreatif dan berwawasan luas yang Islami.",
                ].map((misi, idx) => (
                  <li key={idx} className="flex gap-3 text-sm text-gray-700">
                    <span className="w-6 h-6 rounded-full flex items-center justify-center font-bold text-xs flex-shrink-0 text-white" style={{ backgroundColor: "#198530" }}>
                      {idx + 1}
                    </span>
                    {misi}
                  </li>
                ))}
              </ol>
            </div>
          </div>
          {/* Motto */}
          <div className="rounded-xl p-6 text-center" style={{ backgroundColor: "#d4af37", color: "#044712" }}>
            <p className="text-2xl mb-2" style={{ fontFamily: "'Amiri', serif" }}>
              الذِّكْرُ وَالفِكْرُ وَالعَمَلُ الصَّالِحُ وَالبَرَكَةُ
            </p>
            <p className="font-bold text-lg">Motto: Zikir, Fikir, Amal Sholeh, dan Barokah</p>
          </div>
        </div>
      </section>

      {/* Program Pendidikan */}
      <section className="py-12" style={{ backgroundColor: "#F8FAF8" }}>
        <div className="max-w-5xl mx-auto px-4">
          <div className="text-center mb-10">
            <p className="text-sm uppercase tracking-widest font-semibold mb-2" style={{ color: "#d4af37" }}>
              Jenjang Pendidikan
            </p>
            <h2 className="text-3xl font-bold text-gray-900">Program Pendidikan</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {programs.map((prog, idx) => (
              <div
                key={idx}
                className="rounded-xl p-6 flex items-start gap-4"
                style={{ backgroundColor: PROGRAM_COLORS[idx % PROGRAM_COLORS.length], border: "1px solid #e5e7eb" }}
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center font-bold text-white text-sm flex-shrink-0"
                  style={{ backgroundColor: "#198530" }}
                >
                  {prog.level}
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-sm">{prog.name}</h3>
                  <p className="text-xs text-gray-500 mt-1 leading-relaxed">{prog.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Management Structure */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          <div className="text-center mb-10">
            <p className="text-sm uppercase tracking-widest font-semibold mb-2" style={{ color: "#d4af37" }}>
              Struktur Organisasi
            </p>
            <h2 className="text-3xl font-bold text-gray-900">Pengelola Madrasah Ibtidaiyah Al-Armi</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {management.map((person, idx) => (
              <div
                key={person.id}
                data-testid={`management-${idx + 1}`}
                className="flex items-center gap-4 bg-white rounded-xl p-4 transition-all duration-200"
                style={{ border: "1px solid #f0fdf4" }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "#86efac";
                  e.currentTarget.style.backgroundColor = "#f0fdf4";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "#f0fdf4";
                  e.currentTarget.style.backgroundColor = "white";
                }}
              >
                {person.photo ? (
                  <img src={person.photo} alt={person.name} className="w-11 h-11 rounded-full object-cover flex-shrink-0" />
                ) : (
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0 text-white"
                    style={{ backgroundColor: "#198530" }}
                  >
                    {idx + 1}
                  </div>
                )}
                <div>
                  <p className="font-semibold text-gray-900 text-sm">{person.name}</p>
                  <p className="text-xs font-medium" style={{ color: "#198530" }}>{person.position}</p>
                </div>
              </div>
            ))}
          </div>
          {management.length === 0 && <p className="text-center text-gray-400 py-6">Memuat data pengurus...</p>}
        </div>
      </section>
    </div>
  );
}
